/**
 * Generated bundle index. Do not edit.
 */

export * from './public-api';

export {NGX_LOADING_X_TOKEN as Éµa} from './lib/ngx-loading-x-config.token';